module.exports = __webpack_public_path__ + "static/media/sideBarCricket.db454117.svg";